import { EmployeeProfileTranslation } from '@/assets/locales/views/employeeProfile/employeeProfile.translation.pl.ts';
import { employeeProfileAiSummarySectionTranslation } from '@/assets/locales/views/employeeProfile/sections/aiSummary/employeeProfile.aiSummary.translation.en.ts';
import { employeeProfileBasicSectionTranslation } from '@/assets/locales/views/employeeProfile/sections/basic/employeeProfile.basic.translation.en.ts';
import { employeeProfileChatFormSectionTranslation } from '@/assets/locales/views/employeeProfile/sections/chat/employeeProfile.chat.translation.en.ts';
import { employeeProfileCorporateTrainingsSectionTranslation } from '@/assets/locales/views/employeeProfile/sections/corporateTrainings/employeeProfile.corporateTrainings.translation.en.ts';
import { employeeProfileDevelopmentChatFormSectionTranslation } from '@/assets/locales/views/employeeProfile/sections/developmentChat/employeeProfile.chat.translation.en.ts';
import { employeeProfileDevelopmentPlanSectionTranslation } from '@/assets/locales/views/employeeProfile/sections/developmentPlan/employeeProfile.developmentPlan.translation.en.ts';
import { employeeProfileGradeSystemSectionTranslation } from '@/assets/locales/views/employeeProfile/sections/gradeSystem/employeeProfile.gradeSystem.translation.en.ts';
import { employeeProfileOrganizationalAssignmentSectionTranslation } from '@/assets/locales/views/employeeProfile/sections/organizationalAssignment/employeeProfile.organizationalAssignment.translation.en.ts';
import { employeeProfilePotentialOverviewSectionTranslation } from '@/assets/locales/views/employeeProfile/sections/potentialOverview/employeeProfile.potentialOverview.translation.en.ts';

export const employeeProfileTranslation: EmployeeProfileTranslation = {
  aiSummary: employeeProfileAiSummarySectionTranslation,
  basic: employeeProfileBasicSectionTranslation,
  chat: employeeProfileChatFormSectionTranslation,
  corporateTrainings: employeeProfileCorporateTrainingsSectionTranslation,
  developmentChat: employeeProfileDevelopmentChatFormSectionTranslation,
  developmentPlan: employeeProfileDevelopmentPlanSectionTranslation,
  downloadFlashcard: 'Download Flashcard',
  generatingFlashcard: 'Generating...',
  goToDevelopmentChat: 'Build a development path',
  gradeSystem: employeeProfileGradeSystemSectionTranslation,
  noAccess: {
    description:
      'You do not have permission to view this profile. Please contact your administrator if you believe this is an error.',
    title: 'Access Denied',
  },
  noApplicationAccess: {
    description:
      'You do not have permission to access the application. Please contact your administrator if you believe this is an error.',
    title: 'Access Denied',
  },
  noPermissions: {
    confirmButton: 'Back to search',
    description:
      'You do not have permission to view any sections of this employee profile. Please contact your administrator if you believe this is an error.',
    title: 'No Permissions',
  },
  organizationalAssignment: employeeProfileOrganizationalAssignmentSectionTranslation,
  potentialOverview: employeeProfilePotentialOverviewSectionTranslation,
  roleSelectionModal: {
    cancelButton: 'Cancel',
    confirmButton: 'Select',
    content: 'Select the role with which you want to view the profile:',
    title: 'Role Selection',
  },
  util: {
    yearsMonths: '{{years}} years, {{months}} months',
  },
  viewingAs: 'Viewing profile as:',
};
